import gql from 'graphql-tag'
import { absenceFragment, absenceTypeFragment } from '@/graphql/absence/absenceFragments'

export const ABSENCETYPES = gql`
    query absenceTypes(
        $trashed: Trashed
    ){
        absenceTypes(
            trashed: $trashed
        ){
            ...absenceTypeFragment
        }
    }
    ${absenceTypeFragment}
`
// export const ABSENCETYPESABSENCES = gql`
//     query absenceTypes(
//         $model: ApplyToModels!
//     ){
//         absenceTypes{
//             ...absenceTypeFragment
//             absences(
//                 model: $model
//             ){
//                 ...absenceFragment
//                 type{
//                     ...absenceTypeFragment
//                 }
//             }
//         }
//     }
//     ${absenceFragment}
//     ${absenceTypeFragment}
// `

export const ABSENCES = gql`
    query absences(
        $ids: [ID]
        $page: Int
        $first: Int
    ){
        absences(
            ids: $ids
            page: $page
            first: $first
        ){
            data{
                ...absenceFragment
                type{
                    ...absenceTypeFragment
                }
            }
        }
    }
    ${absenceFragment}
    ${absenceTypeFragment}
`

export const USERABSENCES = gql`
    query userAbsences(
        $userProfileID: ID
        $dateRange: activeDuringInputSingleDate
    ){
        userAbsences(
            userProfileID: $userProfileID
            dateRange: $dateRange
        ){
            data{
                ...absenceFragment
                type{
                    ...absenceTypeFragment
                }
            }
        }
    }
    ${absenceFragment}
    ${absenceTypeFragment}
`